module.exports = __webpack_public_path__ + "static/media/flowMobile.0a77c5d4.jpg";